/* share social */
import $ from "jquery";

$(function() {
    var toggle = $('.socialShareToggle');

    toggle.click(function() {
        event.preventDefault();
        $(this)
            .siblings('.socialShareContent')
            .toggleClass('__active');
    });
});
